import { API } from '../../providers/ApiInterceptorProvider';

export const applicationsApi = {
  getAll: async () => {
    try {
      const { data } = await API.get<Record<string, string>>(`/application/broker`);

      return data;
    } catch (err: any) {
      throw new Error(err.response.data.message);
    }
  },
};
